module.exports = __webpack_public_path__ + "src/assets/animations/lavender.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/animations/lavender.png
// module id = ./src/assets/animations/lavender.png
// module chunks = 0